import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, ChevronRight } from 'lucide-react';
export function DonateModule() {
  const [isMonthly, setIsMonthly] = useState(true);
  const [selectedAmount, setSelectedAmount] = useState<number | 'custom'>(100);
  const [customAmount, setCustomAmount] = useState<string>('');
  const presetAmounts = [25, 50, 100, 250, 500, 1000];
  // Sample progress data
  const goal = 500000;
  const raised = 342500;
  const percentComplete = raised / goal * 100;
  return <div className="bg-white rounded-xl shadow-2xl overflow-hidden border border-slate-200 w-full max-w-md mx-auto" data-id="element-16">
      {/* Header / Progress */}
      <div className="bg-slate-50 p-6 border-b border-slate-200" data-id="element-17">
        <h3 className="font-serif font-bold text-2xl text-pac-navy text-center mb-4 uppercase tracking-wide" data-id="element-18">
          Defend Local Control
        </h3>

        <div className="mb-2 flex justify-between text-sm font-bold" data-id="element-19">
          <span className="text-pac-blue" data-id="element-20">
            ${(raised / 1000).toFixed(1)}k Raised
          </span>
          <span className="text-slate-500" data-id="element-21">
            Goal: ${(goal / 1000).toFixed(0)}k
          </span>
        </div>
        <div className="w-full bg-slate-200 rounded-full h-3 mb-2 overflow-hidden" data-id="element-22">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: `${percentComplete}%`
        }} transition={{
          duration: 1.5,
          ease: 'easeOut'
        }} className="bg-pac-gold h-3 rounded-full" data-id="element-23" />
        </div>
        <p className="text-xs text-center text-slate-500 font-medium" data-id="element-24">
          Join 1,847 other West Valley leaders today.
        </p>
      </div>

      <div className="p-6" data-id="element-25">
        {/* Frequency Toggle */}
        <div className="flex p-1 bg-slate-100 rounded-lg mb-6" data-id="element-26">
          <button onClick={() => setIsMonthly(false)} className={`flex-1 py-2.5 text-sm font-bold rounded-md transition-all ${!isMonthly ? 'bg-white text-pac-navy shadow-sm border border-slate-200' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-27">
            One-Time
          </button>
          <button onClick={() => setIsMonthly(true)} className={`flex-1 py-2.5 text-sm font-bold rounded-md transition-all ${isMonthly ? 'bg-pac-navy text-white shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-28">
            Monthly
          </button>
        </div>

        {/* Amount Grid */}
        <div className="grid grid-cols-3 gap-3 mb-4" data-id="element-29">
          {presetAmounts.map(amount => <button key={amount} onClick={() => {
          setSelectedAmount(amount);
          setCustomAmount('');
        }} className={`py-3 rounded border-2 font-bold text-lg transition-all ${selectedAmount === amount ? 'border-pac-red bg-red-50 text-pac-red' : 'border-slate-200 text-slate-700 hover:border-pac-blue hover:text-pac-blue'}`} data-id="element-30">
              ${amount}
            </button>)}
        </div>

        {/* Custom Amount */}
        <div className="mb-6" data-id="element-31">
          <div className={`relative flex items-center border-2 rounded transition-all ${selectedAmount === 'custom' ? 'border-pac-red bg-red-50' : 'border-slate-200'}`} data-id="element-32">
            <span className={`pl-4 font-bold ${selectedAmount === 'custom' ? 'text-pac-red' : 'text-slate-500'}`} data-id="element-33">
              $
            </span>
            <input type="number" placeholder="Other Amount" value={customAmount} onChange={e => {
            setSelectedAmount('custom');
            setCustomAmount(e.target.value);
          }} onFocus={() => setSelectedAmount('custom')} className="w-full py-3 px-2 bg-transparent outline-none font-bold text-slate-700 placeholder:text-slate-400 placeholder:font-normal" data-id="element-34" />
          </div>
        </div>

        {/* CTA Button */}
        <button className="w-full bg-pac-red hover:bg-red-800 text-white py-4 rounded font-bold text-xl uppercase tracking-wider transition-all shadow-[0_4px_14px_0_rgba(185,28,28,0.39)] hover:shadow-[0_6px_20px_rgba(185,28,28,0.23)] hover:-translate-y-0.5 flex items-center justify-center gap-2 group" data-id="element-35">
          Contribute Now
          <ChevronRight className="h-6 w-6 group-hover:translate-x-1 transition-transform" data-id="element-36" />
        </button>

        {/* Security / Disclaimer */}
        <div className="mt-4 flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-37">
          <Lock className="h-3 w-3" data-id="element-38" />
          <span data-id="element-39">Secure, encrypted transaction</span>
        </div>
      </div>
    </div>;
}